import NonAcademicJobPositions from './NonAcademicJobPositions.component';

export default NonAcademicJobPositions;
